import styled, { css } from 'styled-components'
import Colors from 'constants/colors'
import Threshold from 'constants/threshold'

export const IconBase = styled.div`
  color: #fff;
  width: 20px;
  height: 20px;
`

export const IconLeft = styled(IconBase)`
  margin-right: 10px;
`
export const IconRight = styled(IconBase)`
  margin-left: 10px;
`

export const Base = styled.div`
  display: flex;
  flex-direction: row;
`

export const Button = styled.div<{
  colorText: string
  colorBtn: string
  outlined?: boolean
  contained?: boolean
  big?: boolean
}>`
  z-index: 10;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: ${props => (props.big ? '70px' : '54px')};
  min-width: 220px;
  max-width: 380px;
  padding: 0 20px;
  border-radius: 2px;
  transition: background-color 0.3s ease-out;
  font-size: 16px;
  line-height: 35px;
  font-weight: bold;
  text-align: center;
  outline: none;
  text-decoration: none;
  cursor: pointer;
  width: 100%;

  svg path {
    fill: ${props => {
      if (props.outlined) return props.colorBtn
      if (props.contained) return props.colorText
      return 'initial'
    }};
  }
  color: ${props => {
    if (props.outlined) return props.colorBtn
    if (props.contained) return props.colorText
    return 'initial'
  }};
  border: ${props => {
    if (props.outlined) return `2px solid ${props.colorBtn}`
    if (props.contained) return `2px solid ${props.colorBtn}`
    return 'none'
  }};
  background-color: ${props => {
    if (props.contained) return props.colorBtn
    return 'initial'
  }};

  &:hover {
    background-color: ${props => {
      if (props.contained) return props.colorBtn
      if (props.outlined) return '#d2d7fc'
      return 'initial'
    }};
    opacity: ${props => props.contained && 0.5};

    & svg path {
      fill: ${props => props.contained && props.colorText};
    }
  }
  &:active {
    opacity: 1;
    border: ${props => {
      if (props.outlined) return `2px solid ${props.colorBtn}`
      if (props.contained) return `2px solid ${props.colorBtn}`
      return 'none'
    }};

    background-color: ${props => {
      if (props.outlined) return props.colorBtn
      if (props.contained) return '#d2d7fc'
      return 'initial'
    }};
    color: ${props => {
      if (props.outlined) return props.colorText
      if (props.contained) return props.colorBtn
      return 'initial'
    }};

    & svg path {
      fill: ${props => {
        if (props.outlined) return props.colorText
        if (props.contained) return props.colorBtn
        return 'initial'
      }};
    }
  }
`
